exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 10px 0;\n}\n.container .horizontal-flex-box {\n  display: flex;\n}\n.event-form__buttons-box {\n  position: absolute;\n  display: none;\n  top: 2px;\n  right: 2px;\n}\n.event-form__buttons-box #event-form-delete.event-button {\n  font-size: 1.5em;\n  background: none;\n  border: none;\n  padding: 0;\n  outline: none;\n}\n.container:hover .event-form__buttons-box {\n  display: block;\n}", ""]);

// exports
